import React, { useEffect, useState } from 'react';

import { useAuth } from '../../security/authContext';
import apiAuth from '../../services/apiAuth';
import apiShipper from '../../services/apiShipper';
import { Spin, Tabs } from '../../styles/global';
import { GlobalStyle } from './styles';
import TabEmpresa from './Tabs/TabEmpresa';
import TabMeuPerfil from './Tabs/TabMeuPerfil';

const { TabPane } = Tabs;

export default function PerfilUsuario() {
  const { user } = useAuth();

  const [currentTab, setCurrentTab] = useState(1);
  const [currentUser, setCurrentUser] = useState(user);
  const [loading, setLoading] = useState(false);
  const [selectedPermissions, setSelectedPermissions] = useState();
  const [arrayClientesMatriz, setArrayClientesMatriz] = useState([]);
  const [arrayClientesPagadores, setArrayClientesPagadores] = useState([]);
  const [selectedPermissionsBack, setSelectedPermissionsBack] = useState();

  const onTabClickChange = value => setCurrentTab(Number(value));

  const tabs = [
    {
      key: '1',
      title: 'Meu perfil',
      content: (
        <TabMeuPerfil
          user={currentUser}
          selectedPermissions={selectedPermissions}
          setSelectedPermissions={setSelectedPermissions}
          setLoading={setLoading}
          selectedPermissionsBack={selectedPermissionsBack}
          setSelectedPermissionsBack={setSelectedPermissionsBack}
        />
      ),
    },
    {
      key: '2',
      title: 'Empresa',
      content: (
        <TabEmpresa
          arrayClientesMatriz={arrayClientesMatriz}
          arrayClientesPagadores={arrayClientesPagadores}
        />
      ),
    },
  ];

  useEffect(() => {
    async function onInit() {
      try {
        setLoading(true);

        const { data } = await apiAuth.get(`/users/${user.id}`);

        setCurrentUser({
          id: data.id,
          name: data.name,
          phone_number: data.phone_number,
          email: data.email,
          cpf: data.cpf,
          login: data.login,
        });

        setArrayClientesPagadores(data.pagadores);

        if (data.permissions && data.permissions.length > 0) {
          setSelectedPermissions(data.permissions);
        }

        const idClientes =
          user.cliente_id_secundarios && user.cliente_id_secundarios.length > 0
            ? `${user.cliente_id_secundarios},${user.cliente_id}`
            : `${user.cliente_id}`;

        const result = await apiShipper.get('/clientes', {
          params: {
            idClienteSecundarios: idClientes,
          },
        });

        setArrayClientesMatriz(result.data.content);
      } finally {
        setLoading(false);
      }
    }
    onInit();
  }, [user.id, user]);

  return (
    <>
      <GlobalStyle />
      <Spin size="large" spinning={loading}>
        <Tabs activeKey={currentTab.toString()} onTabClick={onTabClickChange}>
          {tabs.map(item => (
            <TabPane tab={item.title} key={item.key}>
              {item.content}
            </TabPane>
          ))}
        </Tabs>
      </Spin>
    </>
  );
}
